import React, { useEffect, useState } from 'react'
import '../../Assets/CSS/Annexures.css'
import { Icon } from "@iconify/react";
import axios from 'axios';
import toast from 'react-hot-toast';

const SalaryComponent = () => {

  const [formdata, setFormData] = useState({
    componentName: "",
    componentDescription: "",
    componentType: ""
  });

  const [list, setList] = useState([]);

  const [errors, setErrors] = useState({
    componentName: "",
    componentDescription: "",
    componentType: ""
  });

const [openId, setOpenId] = useState(null);

const toggleAccordion = (id) => {
  setOpenId(openId === id ? null : id);
};



  // -------------------- VALIDATION --------------------
  const validate = () => {
    let isValid = true;

    let newErrors = {
      componentName: "",
      componentDescription: "",
      componentType: ""
    };

    if (!formdata.componentName.trim()) {
      newErrors.componentName = "Component Name is required";
      isValid = false;
    }

    if (!formdata.componentDescription.trim()) {
      newErrors.componentDescription = "Component Description is required";
      isValid = false;
    }

    if (!formdata.componentType.trim()) {
      newErrors.componentType = "Component Type is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };




const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
};


  const handleAdd = async () => {
    if (!validate()) return;
    const token = localStorage.getItem("token")

console.log("Salary Componant token ",token)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary-components`,
        formdata,
        {
          headers: {
              "Content-Type": "application/json",

             Authorization: `Bearer ${token}`,
          }
        }
      );

      console.log("Salary Componant API Response:", response.data);
      toast.success("Salary Componant Added Successfully")

   

      // Clear form
      setFormData({
        componentName: "",
        componentDescription: "",
        componentType: ""
      });

    } catch (error) {
      console.error("API Error Salary Componant:", error);
      toast.error("Salary Componant Not Added Successfully")
    }
  };



  const fetchComponents = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary-components`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    );

    console.log("Get Salary Components API:", response.data);

    setList(response.data);  // Save into state

  } catch (error) {
    console.error("Get API Error:", error.response?.data || error);
  }
};

  useEffect(() => {
  fetchComponents();
}, []);

  const handleDelete = (id) => {
    setList(list.filter((item) => item.id !== id));
  };


  return (
    <div>
      <div className='backgrond-color p-4' >
        <p className='fs'>Create New Component</p>


        <div className="row g-3">
          {/* COMPONENT NAME */}
          <div className="col-12 col-sm-6">
            <input
              className="form-control"
              type="text"
              placeholder="Component Name*"
              value={formdata.componentName}
              onChange={(e) => {
                setFormData({ ...formdata, componentName: e.target.value });
                if (errors.componentName) setErrors({ ...errors, componentName: "" });
              }}
              style={{ width: "100%", borderRadius: "8px", border: "1px solid #C8C8C8", height: "40px", paddingLeft: "12px", fontSize: "14px", color: "#606060",}}
            />
            {errors.componentName && (
              <p style={{ color: "red", fontSize: "12px" }}>{errors.componentName}</p>
            )}
          </div>
              {/* COMPONENT TYPE */}
          <div className="col-12 col-sm-6">
            <select
              className="form-control custom-select"
              value={formdata.componentType}
              onChange={(e) => {
                setFormData({ ...formdata, componentType: e.target.value });
                if (errors.componentType) setErrors({ ...errors, componentType: "" });
              }}
              style={{
                width: "100%",
                height: "40px",
                borderRadius: "8px",
                border: "1px solid #C8C8C8",
                paddingLeft: "12px",
                fontSize: "14px",
                color: "#606060",
              }}
            >
              <option value="">Select Component Type</option>
              <option value="EARNING">EARNING</option>
              <option value="DEDUCTION">DEDUCTION</option>
            </select>

            {errors.componentType && (
              <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                {errors.componentType}
              </p>
            )}
          </div>


          {/* COMPONENT DESCRIPTION */}
          <div className="col-12">
            <textarea
              className="form-control"
              type="text"
              placeholder="Component Description"
              value={formdata.componentDescription}
              onChange={(e) => {
                setFormData({ ...formdata, componentDescription: e.target.value });
                if (errors.componentDescription) setErrors({ ...errors, componentDescription: "" });
              }}
               style={{ width: "100%", borderRadius: "8px", border: "1px solid #C8C8C8", height: "70px", paddingLeft: "12px", fontSize: "14px", color: "#606060",}}
            />
            {errors.componentDescription && (
              <p style={{ color: "red", fontSize: "12px" }}>{errors.componentDescription}</p>
            )}
          </div>


      

        </div>


        <div>
          {/* Add Button */}
     
          <button
            onClick={handleAdd}
            className="add-btn"
            style={{ width: "106px", height: "40px", marginTop: "15px" , justifyContent: 'center'}}
          >
            Add
          </button>
        </div>
      </div>



   

<div className='p-3' style={{ marginTop: "30px" }}>

  {list.length > 0 && <p>Component List</p>}

  {list.map(item => {
    const isOpen = openId === item.salaryComponentId;

    const prefix = item.componentType === "EARNING" ? "+ " : "- ";
    const prefixColor = item.componentType === "EARNING" ? "#0FA958" : "#E34234";

    return (
      <div
        key={item.salaryComponentId}
        className="mb-3 p-3 annexelist"
        style={{
          borderRadius: "8px",
          transition: "0.3s",
          cursor: "pointer",
        }}
      >
        {/* TOP ROW */}
        <div onClick={() => toggleAccordion(item.salaryComponentId)}>

          {/* -------------------- MOBILE VIEW -------------------- */}
          <div
            className="d-flex d-sm-none w-100"
            style={{
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            {/* PREFIX + NAME */}
            <p
              style={{
                flex: 1,
                minWidth: 0,
                margin: 0,
                fontWeight: 600,
                fontSize: "14px",
                color: prefixColor,
                wordBreak: "break-word",
                lineHeight: "18px",
              }}
            >
              {prefix}{item.componentName}
            </p>

            {/* ARROW */}
            <div style={{ flexShrink: 0 }}>
              <Icon
                icon={isOpen ? "mdi:chevron-up" : "mdi:chevron-down"}
                style={{
                  fontSize: "22px",
                  color: "#606060",
                }}
              />
            </div>
          </div>

          {/* MOBILE ROW 2 → DATE + DELETE */}
          <div className="d-flex d-sm-none justify-content-between align-items-center w-100 mt-2">
            <p style={{ fontSize: "12px", color: "#909090", margin: 0 }}>
              {formatDate(item.createdAt)}
            </p>

            <Icon
              icon="material-symbols:delete-outline"
              style={{ fontSize: "18px", color: "#606060" }}
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(item.salaryComponentId);
              }}
            />
          </div>

          {/* -------------------- DESKTOP VIEW -------------------- */}
          <div className="d-none d-sm-flex justify-content-between align-items-center">

            {/* LEFT SIDE NAME */}
            <p
              className="m-0"
              style={{
                fontWeight: 600,
                fontSize: "14px",
                color: prefixColor,
              }}
            >
              {prefix}{item.componentName}
            </p>

            {/* RIGHT SIDE: DATE + DELETE + ARROW */}
            <div className="d-flex align-items-center gap-5">
              <p style={{ fontSize: "12px", color: "#909090", margin: 0 }}>
                {formatDate(item.createdAt)}
              </p>

              <Icon
                icon="material-symbols:delete-outline"
                className="delete-icon"
                style={{ fontSize: "18px", color: "#606060" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(item.salaryComponentId);
                }}
              />

              <Icon
                icon={isOpen ? "mdi:chevron-up" : "mdi:chevron-down"}
                style={{
                  fontSize: "22px",
                  color: "#606060",
                }}
              />
            </div>
          </div>
        </div>

        {/* EXPANDED DESCRIPTION */}
        {isOpen && (
          <div
            className="mt-3"
            style={{
              borderTop: "1px solid #dcdcdc",
              paddingTop: "10px",
              color: "#606060",
              fontSize: "13px",
            }}
          >
            {item.componentDescription}
          </div>
        )}
      </div>
    );
  })}
</div>




    </div>


  )
}

export default SalaryComponent